var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIncrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.98604 14.364C0.98604 14.7229 1.27705 15.014 1.63604 15.014L7.48604 15.014C7.84502 15.014 8.13604 14.7229 8.13604 14.364C8.13604 14.005 7.84502 13.714 7.48604 13.714L2.28604 13.714L2.28604 8.51395C2.28604 8.15497 1.99502 7.86395 1.63604 7.86395C1.27706 7.86395 0.98604 8.15497 0.98604 8.51395L0.98604 14.364ZM15.014 1.63603C15.014 1.27705 14.7229 0.98603 14.364 0.986031L8.51396 0.986031C8.15498 0.98603 7.86396 1.27705 7.86396 1.63603C7.86396 1.99502 8.15498 2.28603 8.51396 2.28603L13.714 2.28603L13.714 7.48603C13.714 7.84502 14.005 8.13603 14.364 8.13603C14.7229 8.13603 15.014 7.84502 15.014 7.48603L15.014 1.63603ZM2.09566 14.8236L14.8236 2.09565L13.9043 1.17641L1.17642 13.9043L2.09566 14.8236Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIncrease);
export default __webpack_public_path__ + "static/media/arrow_increase.2db1e640a17d9e36b1c8de26cdbb9b03.svg";
export { ForwardRef as ReactComponent };